import "./OtpInputField.scss";
import OtpInput from "react-otp-input";

const OtpInputField = ({
  name,
  value,
  numOfInputs = 4,
  onChange,
  secret = false,
}) => {
  // Filter input to only allow digits
  const handleOtpChange = (otp) => {
    const numericOnly = otp?.replace(/\D/g, "");

    onChange(numericOnly);
  };

  return (
    <div className="otp-input__field">
      <OtpInput
        className="otp-input__field"
        value={value}
        name={name}
        numInputs={numOfInputs}
        isInputNum={true}
        shouldAutoFocus={true}
        isInputSecure={secret}
        inputType={secret ? "password" : "number"}
        inputMode="numeric"
        onChange={handleOtpChange}
        renderInput={(props) => <input {...props} />}
      />
    </div>
  );
};

export default OtpInputField;
